import { render, staticRenderFns } from "./RegexItem.vue?vue&type=template&id=02c6ec5c&"
import script from "./RegexItem.vue?vue&type=script&lang=ts&"
export * from "./RegexItem.vue?vue&type=script&lang=ts&"
import style0 from "./RegexItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports